<template>
  <a-form-model class="reg-form" :model="registerForm"
                ref="registerForm"
                :rules="rules"
                :labelCol="{style:{width:'100px'}}">
    <div class="reg-wx">
      <a-form-model-item label="">
        <div class="reg-wx-title">绑定微信</div>
        <div class="bind_wx_wrapper">
          <img :src="wxImg" width="180" height="180" style="display: block;" alt="">
          <div class="wx_tip" v-if="wxShow">
            <p>扫码绑定微信，下次登录更方便</p>
          </div>
          <div class="wx_tip" v-else>
            <p>微信扫码成功</p>
          </div>
        </div>
      </a-form-model-item>
    </div>
    <div class="vertical-line"></div>
    <div :style="{width: '372px',
                  height: '428px',
                  overflow: 'hidden',}">  
      <template v-if="registerType === 'email'">
        <h1>欢迎来到91家纺网</h1>
        <a-form-model-item  label="" prop="country">
          <a-select size="large" show-search placeholder="请选择国家" v-model="registerForm.country" option-filter-prop="children" :disabled="select_disabled">
            <a-select-option v-for="item in countryList" :key="item.id" :value="item.id">
              {{ item.name_cn }}({{ item.name_en }})
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item  label="" prop="email">
          <a-input class="register_mobile" v-model="registerForm.email"  @focus='clearTips' placeholder="请输入邮箱" />
        </a-form-model-item>
        <a-form-model-item label="" prop="imgCode" ref="imgCode">
          <div class="code_parent">
            <div>
              <a-input class="register_code" v-model="registerForm.imgCode" type="text" placeholder="输入图形验证码" ref="inputImgCode" @blur="() => {$refs.imgCode.onFieldBlur()}" @focus='clearTips' />
            </div>
            <img class="register_code_img" :src="imgCode" @click="getImgCode" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="" prop="emailCode" ref="emailCode">
          <div class="mobile_code">
              <div>
                <a-input class="mobile_input" v-model="registerForm.emailCode" type="text" placeholder="请输入邮箱验证码" @focus='clearTips' />
              </div>
              <span class="btn_sms_code" @click="getEmailCode">{{this.enableGetSmsCode ? '获取验证码' : `${this.smsCodeTime}秒后获取`}}</span>
          </div>
          <template #help><span class="tips">{{help}}</span></template>
        </a-form-model-item>
      </template>
      <template v-else>
        <a-tabs class="reg-tab" :default-active-key="registerType === 'person'?'1':'2'" @change="changeRegisterType" style="margin-bottom: 20px;">
          <a-tab-pane key="1" tab="个人注册"></a-tab-pane>
          <a-tab-pane key="2" tab="企业注册"></a-tab-pane>
        </a-tabs>
  
        <div class="steps" v-if="registerType === 'store'">
          <div class="on"><div>1</div><div>用户信息</div></div>
          <div><div>2</div><div>身份核验</div></div>
          <div><div>3</div><div>商家信息</div></div>
          <div><div>4</div><div>登录会员中心</div></div>
        </div>
  
        <a-form-model-item  label="" prop="mobile">
          <a-input class="register_mobile" v-model="registerForm.mobile"  @focus='clearTips' placeholder="输入手机号码" />
        </a-form-model-item>
        <a-form-model-item label="" prop="imgCode" ref="imgCode">
          <div class="code_parent">
            <div>
              <a-input class="register_code" v-model="registerForm.imgCode" type="text" placeholder="输入图形验证码" ref="inputImgCode" @blur="() => {$refs.imgCode.onFieldBlur()}" @focus='clearTips' />
            </div>
            <img class="register_code_img" :src="imgCode" @click="getImgCode" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="" prop="smsCode" ref="smsCode">
          <div class="mobile_code">
              <div>
                <a-input class="mobile_input" v-model="registerForm.smsCode" type="text" placeholder="输入短信验证码" @change="() => {$refs.smsCode.onFieldChange()}" @focus='clearTips' />
              </div>
              <span class="btn_sms_code" @click="getSmsCode">{{this.enableGetSmsCode ? '获取验证码' : `${this.smsCodeTime}秒后获取`}}</span>
          </div>
          <template #help><span class="tips">{{help}}</span></template>
        </a-form-model-item>
        <a-form-model-item label="" prop="type" ref="type" style="margin-top: 0px;" v-if="registerType === 'person'">
          <div class="person_type">
            <a-radio-group default-value="0" size="large" v-model="registerForm.type" >
              <a-radio-button value="1">我是采购商</a-radio-button>
              <a-radio-button style="margin-left: 10px;" value="0">我是个人用户</a-radio-button>
            </a-radio-group>
          </div>
        </a-form-model-item>
      </template>
      <a-form-model-item :wrapperCol="{span:24}" class="register_btn">
        <a-button v-if="(registerType === 'person' && registerForm.type=='0') || registerType === 'email'" type="primary" class="btn_register" @click="register" :class="is_click==='false'?'click_btn':''">立即注册</a-button>
        <a-button v-else type="primary" class="btn_register" @click="nextStep" :class="is_click==='false'?'click_btn':''">下一步</a-button>
        <div class="login-link">
          <!-- <img :src="registerType === 'person' ? ic_company : ic_person" :width="registerType === 'person' ? '14px' : '18px'" height="18px">
          <a-button type="link" @click="changeRegisterType">{{registerType === 'person'? '企业用户注册' : '个人用户注册'}}</a-button> -->
          <a-button v-if="registerType == 'email'" type="link" class="email_btn" @click="goMobile"><a-icon type="mobile" theme="filled" />手机号注册</a-button> 
          <a-button v-else-if="showEmail" type="link" class="email_btn" @click="goEmail"><a-icon type="mail" theme="filled" />邮箱注册</a-button> 
          <span>
            <span>已有账号</span>
            <a href="/login" style="margin-right:10px;">立即登录</a>
          </span>
        </div>
      </a-form-model-item>
    </div>      
  </a-form-model>
</template>

<script>
import wxlogin from 'vue-wxlogin';

export default {
  name: 'RegisterForm',
  components: {wxlogin},
  props: {
    registerType: {
      type: String,
      required: false,
      default: 'person'
    }
  },
  data () {
    var checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      }
      //验证手机是否注册
      var _this = this;
      _this.$util.api('/login/register/have/mobile',{'mobile':value},function(res){
        if(res.code != 10000){
          return callback(new Error(res.msg));
        }else{
          callback();
        }
      });
    };
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('email不能为空'));
      }
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if(!regex.test(value)){
        console.log('email格式不正确'); 
        return callback(new Error('email格式不正确'));
      }
      //验证邮箱是否注册
      var _this = this;
      _this.$util.api('/email/has',{'email':value},function(res){
        if(res.code != 10000){
          return callback(new Error(res.msg=='对应账户已登记'?'该邮箱已注册,请更换重试':res.msg));
        }else{
          callback();
        }
      });
    };
    return {
      ic_company: require('@/assets/images/basic/ic_company.png'),
      ic_person: require('@/assets/images/basic/ic_person.png'),
      registerForm: {
        mobile: '',
        email: '',
        imgCode: '',
        smsCode: '',
        emailCode: '',
        public_weixin_unionid: '',
        type: '0',
      },
      rules: {
        imgCode: [
          { required: true, message: '请输入验证码', trigger: ['blur', 'change'] }
        ],
        country: [
          { required:  this.registerType === 'email'?true:false, message: '请选择国家', trigger: ['blur', 'change'] }
        ],
        mobile: [
          { required: this.registerType !== 'email'?true:false, message: '请输入手机号码', trigger: ['blur', 'change'] },
          { validator: this.$validate.mobile, trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        email: [
          { required: this.registerType === 'email'?true:false, message: '请输入email', trigger: ['blur', 'change'] },
          { validator: checkEmail, trigger: 'blur' }
        ],
        smsCode: [
          { required: this.registerType !== 'email'?true:false, message: '请输入动态验证码', trigger: ['blur', 'change'] }
        ],
        emailCode: [
          { required: this.registerType === 'email'?true:false, message: '请输入邮箱证码', trigger: ['blur', 'change'] }
        ],
      },
      enableGetSmsCode: true,
      smsCodeTime: 60,
      imgCode: '',
      help:'',
      appid:'wxf11a9fc1d89d8abf',
      scope:'snsapi_login',
      redirect_uri:'https%3A%2F%2Fwww.91jf.com%2Fnewweb%2Findex.php%3Ftpl%3Dwap%26url%3Dweixin%26act%3Dbind_wx%26gourl%3Dmember%26mobile%3D',
      href_css:"https://www.91jf.com/view/public/css/bind_wx.css",
      self_redirect:'true',
      is_click:'true',
      imgKey: '',
      showWxCode:false,
      myVar:'',
      wxShow:true,
      wxImg:'',
      countryList:[],
      countryIP:'',
      showEmail:true,
      select_disabled:false,
    }
  },
  created() {
    this.getImgCode();
    this.getWxCode();
    this.getCountry();
    // this.getIP();
  },
  mounted() {
  },
  methods: {
    getIP(){
      var _this = this;
      _this.$util.api('/ip/country',{},function(res){
        if(res.code == 10000){
          if(res.data!=='中国' && res.data!=''){
            if(_this.registerType === 'email'){
              _this.getCountry();
            }
            _this.showEmail = true;
            _this.countryIP = res.data;
          }
        }
      });
    },
    changeRegisterType (activeKey) {
      console.log(activeKey);
      if (activeKey === '2') {
        clearInterval(this.myVar);
        this.$router.replace('/reg/store')
      } else {
        clearInterval(this.myVar);
        this.$router.replace({path: '/reg/person', query: {is_show:0}})
      }
    },
    goMobile () {
      clearInterval(this.myVar);
      this.$router.replace({path: '/reg/person', query: {is_show:0}})
    },
    goEmail () {
      clearInterval(this.myVar);
      this.$router.replace({path: '/reg/email', query: {is_show:0}})
    },
    getImgCode() {
      var _this = this;

      _this.$util.api('/code',{},function(res){
          if(res.code == 10000){
              _this.imgCode = res.data.img;
              _this.imgKey = res.data.key;
          }
      });
    },
    getCountry() {
      var _this = this;

      _this.$util.api('/country',{},function(res){
          if(res.code == 10000){
              _this.countryList = res.data;
              _this.countryList.find(item => {
                if(item.name_cn == _this.countryIP){
                  _this.registerForm.country = item.id;
                  _this.select_disabled = true;
                }
              })
          }
      });
    },
    getSmsCode () {
      if (!this.enableGetSmsCode) return
      let validateStatus = true
      this.$refs.registerForm.validateField(['mobile', 'imgCode'], (errorMessage) => {
        if (errorMessage) {
          validateStatus = false
        }
      })
      if (validateStatus) {
        //获取手机短信
        var _this = this;
        let params = {
            mobile: this.registerForm.mobile,
            code: this.registerForm.imgCode + ',' + this.imgKey,
            action: 'register'
        };
        _this.$util.api('/sms',params,function(res){
            if(res.code == 10000 && _this.registerForm.mobile==res.data){
                _this.enableGetSmsCode = false
                let countDown = setInterval(() => {
                  --_this.smsCodeTime
                  if (_this.smsCodeTime === 0) {
                    clearInterval(countDown)
                    _this.enableGetSmsCode = true
                    _this.smsCodeTime = 60
                  }
                }, 1000)
            }else{
              //报错
              _this.help=res.msg;
            }
        })
      }
    },
    getEmailCode () {
      if (!this.enableGetSmsCode) return
      let validateStatus = true
      this.$refs.registerForm.validateField(['email', 'imgCode'], (errorMessage) => {
        if (errorMessage) {
          validateStatus = false
        }
      })
      if (validateStatus) {
        var _this = this;
        let params = {
            email: this.registerForm.email,
            code: this.registerForm.imgCode + ',' + this.imgKey,
        };
        _this.$util.api('/email/code',params,function(res){
            if(res.code == 10000){
                _this.enableGetSmsCode = false
                let countDown = setInterval(() => {
                  --_this.smsCodeTime
                  if (_this.smsCodeTime === 0) {
                    clearInterval(countDown)
                    _this.enableGetSmsCode = true
                    _this.smsCodeTime = 60
                  }
                }, 1000)
            }else{
              //报错
              _this.help=res.msg;
            }
        })
      }
    },
    register () {
      this.$refs.registerForm.validate(status => {
        if (!status) return
        clearInterval(this.myVar);
        this.$emit('register', this.registerForm)
      })
    },
    nextStep(){
      this.$refs.registerForm.validate(status => {
        if (!status) return
        clearInterval(this.myVar);
        var info = this.registerForm;
        info.nextStep = true;
        this.$emit('register', info)
      })
    },
    clearTips(){
        this.help='';
    },
    checkSms(){
      //验证手机短信
      var _this = this;
      _this.$refs.smsCode.onFieldBlur()
      if(_this.registerForm.mobile !='' && _this.registerForm.smsCode !=''){
        let pars = {
            'mobile':_this.registerForm.mobile,
            'sms_code':_this.registerForm.smsCode
        }
        _this.$util.api('/login/register/check/code',pars,function(res){
            if(res.code != 10000){
              _this.$message.error(res.msg)
              _this.is_click='false'

            }else{
              _this.is_click='true'
            }
        });
      }

    },
    //轮询微信扫码结果
    // get_scan_res(){
    //   var _this = this;
    //   _this.myVar =setInterval(function(){
    //     if(_this.appTicket!=''){
    //
    //       _this.$util.api('/login/register/getcode',{'mobile':_this.registerForm.mobile},function(res){
    //         if(res.code == 10000){
    //           _this.registerForm.wx_openid=res.data;
    //           clearInterval(_this.myVar);
    //           _this.wxShow=false
    //         }else if(res.code==10135){
    //           clearInterval(_this.myVar);
    //           _this.wxShow=false
    //         }
    //       });
    //     }
    //
    //   },1000 )//轮询执行
    // },
    //生成二维码
    // createdWxCode(){
    //   var _this = this;
    //   if(_this.registerForm.mobile!='' && _this.showWxCode ==false){
    //     _this.redirect_uri = _this.redirect_uri+_this.registerForm.mobile;
    //     _this.showWxCode = true;
    //     _this.get_scan_res();
    //   }
    // },
    //获取公众号登录的二维码
    getWxCode() {
      var _this = this;
      _this.$util.api('/login/wximg',{},(res)=>{
        if(res.code == 10000){
          return new Promise((resolve, reject)=> {
            _this.wxImg =res.data.qrcode;
            if(_this.wxImg !==''){
              resolve();
            }
          }).then((val)=>{
            _this.wxLogin(res.data.key);
          }).catch((error)=>{

          });
          //验证用户扫码登录
        }
      });
    },
    wxLogin(token){
      var _this = this;
      _this.myVar =setInterval(function(){
        if(token!=''){
          _this.$util.api('/login/check',{token:token},function(res){
            if(res.code == 10000){
              clearInterval(_this.myVar);
              _this.$message.error('微信已绑定，请直接扫码登录');
            }else if(res.code==30154){
              clearInterval(_this.myVar);
              _this.registerForm.public_weixin_unionid = res.msg;
              _this.wxShow = false;
            }
          });
        }

      },3000 )//轮询执行
    },
  }
}
</script>

<style scoped>
.reg-form{
  width: 832px;
  height: 499px;
  flex-shrink: 0;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.52);
  background: #FFF;
  box-shadow: 0 0 8px 0 rgba(253, 89, 2, 0.06);
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

::v-deep .ant-form-item-children {
  display: flex;
  align-items: center;
  height:70px;
}
::v-deep .ant-form-item:last-child .ant-form-item-children {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .ant-input {
  height: 40px;
}

.reg-wx{
  height:240px;
}

.reg-wx-title{
  text-align: center;
}

.img_code {
  width: 116px;
  height: 40px;
  margin-left: 35px;
  border: 1px solid #d8d8d8;
  cursor: pointer;
}
.ant-form-item {
  margin-bottom: 0px !important;
  height: 70px !important;
}
.btn_sms_code {
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  background: #FFF;
}

.btn_sms_code:hover,
.btn_sms_code:focus {
  border-color: #ff6f02;
}

.wx_code{
  position: absolute;
  top: 10px;
  left: 5px;
}

.wx_tip {
  margin-left: 5px;
  color: #666666;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}


.btn_register {
  width: 372px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #FD5902;
  color: #ffffff;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 16px;
  padding: 0px;
  line-height: 50px;
}

::v-deep .ant-btn-link {
  font-size: 14px;
  margin-top: 20px;
}
::v-deep .ant-btn-link:hover span,
::v-deep .ant-btn-link:focus span {
  text-decoration: underline;
}

.ant-radio-button-wrapper{
  width: 180px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  background: #FFF;
  color: #333333;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 50px;
  padding:0px !important;
}

.ant-radio-button-wrapper-checked{
  border: 1px solid #fd5902;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):before{
  background: none;
}

.bind_wx_wrapper {
  height: 180px;
  width: 180px;
}
.register_mobile{
  width: 372px;
  height: 50px;
  padding: 0 20px;
  text-align: left;
  font-size: 14px;
  color: #505050;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  background: #FFF;
}
.register_code{
  margin-right: 12px;
  padding: 0 20px;
  text-align: left;
  font-size: 14px;
  color: #505050;
  border: 1px solid #D8D8D8;
  width: 260px;
  height: 50px;
  border-radius: 8px;
  background: #FFF;
}

.code_parent{
  display: flex;
  align-items: center;
}
.register_code_img{
  width: 100px;
  height: 50px;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
}
.mobile_code{
  display: flex;
  align-items: center;
}
.mobile_input{
  margin-right: 12px;
  padding: 0 20px;
  text-align: left;
  font-size: 14px;
  color: #505050;
  width: 260px;
  height: 50px;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  background: #FFF;
}
.tips{
    color:#f5222d;
}
.register_btn{
  text-align: center;
}
.click_btn{
  pointer-events: none;
}
.vertical-line{
  width: 1px;
  height: 375px;
  background: #E9E9E9;
  margin: 0px 81px 0px 59px;
}

.reg-tab >>> .ant-tabs-ink-bar{
  background-color:#fff !important;
  display: none !important;
}

>>>.ant-tabs-bar{
  text-align: center;
  border-bottom: unset;
  margin: 0;
}

.login-link{
  margin: 10px auto 0px;
  /* text-align: center; */
  line-height: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login-link span{
  color: #999999;
  font-size: 14px;
  font-weight: 400;
}

.login-link a:hover,
.login-link a{
  color: #fd5902;
  font-size: 14px;
  font-weight: 400;
  margin-left: 10px;
}

/deep/ .reg-tab .ant-tabs-tab{
  padding: 0px !important;
  margin:0px !important;
}

/deep/ .reg-tab .ant-tabs-tab:nth-child(2){
  margin-left: 108px !important;
}

.steps{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 30px 0px;
}

.steps>div{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.steps>div:not(:first-child){
  margin-left: 9px;
}

.steps>div>div:first-child{
  width: 24px;
  height: 24px;
  background-color: #BDBDBD;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  line-height: 25px;
  border-radius: 50%;
  text-align: center;
}

.steps>div.on>div:first-child{
  background-color: #FD5902;
}

.steps>div>div:last-child{
  color: #333333;
  font-size: 13px;
  font-weight: 400;
  margin-left: 4px;
  white-space: nowrap;
  word-break: keep-all;
}
>>>.email_btn span{
  color: #333333;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
>>>.ant-select-lg .ant-select-selection--single{
  height: 50px!important;
}
>>>.ant-select-lg .ant-select-selection__rendered{
  line-height: 50px!important;
  margin: 0 20px!important;
  font-size: 14px;
}
>>>.ant-select-lg .ant-select-selection{
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/register/components/RegisterForm.vue